<template>
  <div class="error-wrap">
    <div class="error-code">404</div>
    <h2 class="error-title">页面不存在</h2>
    <p class="error-desc">
      页面地址有误、功能已下架，或当前版本尚未部署该页面。
    </p>

    <div class="btn-box">
      <button class="btn back" @click="goBack">返回上一页</button>
      <button class="btn home" @click="goHome">回到首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageError",
  data() {
    return {};
  },
  methods: {
    // 返回上一页
    goBack() {
      this.$router.back();
    },
    // 跳转首页
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.error-wrap {
  width: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: var(--app-bg);
  transition: background 0.35s ease;

  .error-code {
    font-size: 160px;
    font-weight: 900;
    line-height: 1;
    margin-bottom: 20px;
    color: var(--brand);
    text-shadow: var(--glow);
    animation: floatUp 3s ease-in-out infinite;
    transition: all 0.35s ease;
  }

  .error-title {
    font-size: 28px;
    font-weight: 600;
    margin: 0 0 12px;
    color: var(--title);
    transition: color 0.35s ease;
  }

  .error-desc {
    font-size: 16px;
    max-width: 580px;
    text-align: center;
    line-height: 1.75;
    margin: 0 auto 52px;
    color: var(--text-muted);
    transition: color 0.35s ease;
  }

  .btn-box {
    display: flex;
    gap: 18px;
    flex-wrap: wrap;
    justify-content: center;

    .btn {
      padding: 13px 28px;
      border-radius: var(--card-radius);
      border: none;
      font-size: 15px;
      cursor: pointer;
      transition: all 0.28s ease;
      box-shadow: var(--btn-shadow);
      color: #fff;

      &:hover {
        transform: translateY(-4px);
        box-shadow: var(--btn-shadow), var(--glow);
      }
      &:active {
        transform: translateY(0);
      }
    }

    .back {
      background: rgba(12, 113, 207, 0.8);
    }
    .home {
      background: var(--brand-grad);
    }
  }
}

@keyframes floatUp {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}

// 移动端适配
@media screen and (max-width: 640px) {
  .error-wrap {
    .error-code {
      font-size: 102px;
    }
    .error-title {
      font-size: 22px;
    }
    .btn-box {
      gap: 12px;
      .btn {
        padding: 11px 22px;
        font-size: 14px;
      }
    }
  }
}
</style>
